import { useState } from 'react';
import { generateDots } from './helpers';
export function useRangeDots(props) {
    const { counts, activeItem, visibleItems } = props;
    const lastIndex = visibleItems - 1;
    const [rangeDotsVisible, setRangeDotsVisible] = useState({
        x1: 0,
        x2: lastIndex,
    });
    const dots = generateDots(counts);
    const isLeftInfinityIconVisible = rangeDotsVisible.x1 !== 0;
    const isRightInfinityIconVisible = dots.length - 1 > rangeDotsVisible.x2;
    if (activeItem > rangeDotsVisible.x2) {
        setRangeDotsVisible({
            x1: activeItem - lastIndex,
            x2: activeItem,
        });
    }
    if (activeItem < rangeDotsVisible.x1) {
        setRangeDotsVisible({
            x1: activeItem,
            x2: activeItem + lastIndex,
        });
    }
    return {
        dots,
        rangeDotsVisible,
        isLeftInfinityIconVisible,
        isRightInfinityIconVisible,
    };
}
